// Shared portfolio piece type definitions + small helpers.

export const PIECE_TYPES = [
  { type: "image",      label: "Image / image series", helper: "JPG, PNG, WebP - multiple allowed" },
  { type: "video",      label: "Video",                helper: "YouTube or Vimeo URL - auto-embedded" },
  { type: "pdf",        label: "PDF document",         helper: "Renders inline" },
  { type: "url",        label: "Live URL",             helper: "Website, campaign, or any external link" },
  { type: "figma",      label: "Figma",                helper: "Embedded prototype or file" },
  { type: "case_study", label: "Case study",           helper: "Problem · Process · Outcome" },
  { type: "audio",      label: "Audio",                helper: "MP3, WAV, M4A, OGG" },
  { type: "on_request", label: "Available on request", helper: "For NDA / unreleased work" },
];

export const WORK_TYPES = [
  "branding", "ux_ui", "photography", "copywriting",
  "motion", "illustration", "web_design", "audio", "other",
];

export function fileUrl(path) {
  if (!path) return null;
  return `${process.env.REACT_APP_BACKEND_URL}/api/files/${path}?auth=public`;
}

// Extract a YouTube video id from many URL shapes.
export function youtubeId(url) {
  if (!url) return null;
  try {
    const u = new URL(url.trim());
    if (u.hostname === "youtu.be") return u.pathname.replace(/^\//, "").split("/")[0] || null;
    if (u.hostname.includes("youtube.com")) {
      if (u.searchParams.get("v")) return u.searchParams.get("v");
      const parts = u.pathname.split("/").filter(Boolean);
      const i = parts.findIndex((p) => p === "embed" || p === "shorts" || p === "v");
      if (i >= 0 && parts[i + 1]) return parts[i + 1];
    }
  } catch {
    // not a URL
  }
  return null;
}

export function vimeoId(url) {
  if (!url) return null;
  try {
    const u = new URL(url.trim());
    if (!u.hostname.includes("vimeo.com")) return null;
    const last = u.pathname.split("/").filter(Boolean).pop();
    return last && /^\d+$/.test(last) ? last : null;
  } catch {
    return null;
  }
}

// Returns an embeddable URL or null if the URL isn't a recognized platform.
export function videoEmbedUrl(url) {
  const yt = youtubeId(url);
  if (yt) return `https://www.youtube.com/embed/${yt}`;
  const v = vimeoId(url);
  if (v) return `https://player.vimeo.com/video/${v}`;
  return null;
}

export function figmaEmbedUrl(url) {
  if (!url) return null;
  try {
    const u = new URL(url.trim());
    if (!u.hostname.includes("figma.com")) return null;
    return `https://www.figma.com/embed?embed_host=share&url=${encodeURIComponent(u.href)}`;
  } catch {
    return null;
  }
}

// Normalize a piece into the new schema, gracefully handling legacy pieces
// that were created before piece_type/visibility/image_paths existed.
export function normalizePiece(p) {
  if (!p) return p;
  const out = { ...p };
  if (!out.piece_type) {
    if (out.image_path && !out.image_paths?.length) out.image_paths = [out.image_path];
    out.piece_type = (out.image_paths?.length || out.image_path) ? "image" : "url";
  }
  if (!out.visibility) out.visibility = "public";
  if (!Array.isArray(out.image_paths)) out.image_paths = out.image_path ? [out.image_path] : [];
  return out;
}

export const WORK_TYPE_LABEL = {
  branding: "Branding",
  ux_ui: "UX / UI",
  photography: "Photography",
  copywriting: "Copywriting",
  motion: "Motion",
  illustration: "Illustration",
  web_design: "Web design",
  audio: "Audio",
  other: "Other",
};
